<template>
    <div class="tz-quotation">
        <div @click="oepnWindow(1)">
            <div>
                <b-img src="/static/image/sina.png" />
            </div>
            <div>
                新浪财经
            </div>
            <div class="open-windows">
                <b-img src="/static/image/system_icon13.png"/>
            </div>
        </div>
        <div @click="oepnWindow(2)">
            <div>
                <b-img src="/static/image/dongfang.png" />
            </div>
            <div>
                东方财富
            </div>
            <div class="open-windows">
                <b-img src="/static/image/system_icon13.png"/>
            </div>
        </div>
        <div @click="oepnWindow(3)">
            <div>
                <b-img src="/static/image/csrc.png" />
            </div>
            <div>
                中国证监会
            </div>
            <div class="open-windows">
                <b-img src="/static/image/system_icon13.png"/>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods:{
        oepnWindow(type){
            let url = '#'
            if(type== 1){
                 url = 'https://vip.stock.finance.sina.com.cn/mkt/'
            }else if( type ==2){
                url = 'http://quote.eastmoney.com/center/'
            }else {
                url = 'http://www.csrc.gov.cn/'
            }
            window.open(url)
        }
    }
}
</script>
<style scoped>
.tz-quotation{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 1rem;
}
.tz-quotation>div{
    width: 100%;
    display: flex;
    max-width: 86rem;
    align-items: center;
    background-color: white;
    margin-top: 1rem;
    padding: 1rem;
    box-shadow: 0 0 5px 1px #e6e9ee;
}
.tz-quotation>div>div:nth-child(2){
    width: 70%;
    align-items: center;
}
.open-windows{
    border-left: 1px solid #e5e5e5;
    padding-left: 2rem;
}
</style>


// WEBPACK FOOTER //
// src/views/system/quotation.vue